import { getBseUrl } from '@/constants';
import { request } from '@umijs/max';
let BASEURL = getBseUrl();

export async function getListPage(params, options) {
  return request(`${BASEURL}/con/recruitments/listPage`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
